import { getLocale } from "../runtime";

const sv_warehousestaffwillpick = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Vår lagerpersonal packar dina varor så snabbt de kan i ett miljövänligt paket.`
};

const warehousestaffwillpick = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_warehousestaffwillpick(inputs)
	return "warehouseStaffWillPick";
};

export { warehousestaffwillpick as "warehouseStaffWillPick" };